module.exports = __webpack_public_path__ + "6b293ca02f954e5c14983b64c177e643.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/roguecompany/windward.png
// module id = 442
// module chunks = 0